<div class="card-body p-3">

    <div class="row">
        <div class="col col-md-3">
            <app-benef-info [beneficiaireAutOselect]="beneficiaireAutOselect"></app-benef-info>

        </div>
        <div class="col col-md-9">
            <div class="row">
                <div class="col-md-12">
                    <app-search-form (sendUserInfo)="onSetUserInfo($event)"></app-search-form>
                </div>


            </div>
            <div *ngIf="itemBeneficiare?.id" class="mt-2">
                <div style="max-height: 200px;overflow-y: auto;">
                    <table class="prescription-table">
                        <thead>
                            <tr>
                                <th scope="col"># <i class="fa fa-redo" (click)="getItemsPrescriptionActive()"></i></th>
                                <th scope="col">Libelle</th>
                                <th scope="col">Date consultation</th>
                                <th scope="col">Date expiration</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr [class.active-row]="item.is_active"
                                *ngFor="let item of itemsPrescription; let i = index" (click)="onSelectRow(item)">
                                <th>{{ i + 1 }}</th>
                                <!-- <td>{{ item.codification }}</td> -->
                                <td>{{ item.libelle }}</td>
                                <td>{{ item.created_at | date:'dd/MM/yyyy' }}</td>
                                <td>
                                    <!-- Add expiration date if available -->
                                    {{ item.date_expiration ? (item.date_expiration | date:'dd/MM/yyyy') : 'N/A' }}
                                </td>
                                <td class="blink">
                                    <!-- Add expiration date if available -->
                                    {{ item.is_controle?'Controle':'' }}
                                </td>
                            </tr>
                            <tr *ngIf="!itemsPrescription || !itemsPrescription.length">
                                <td colspan="5" style="text-align: center;">
                                    Auncune donnée trouvée
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>




                <!-- Medication Add Form -->
                <div class="card mb-4" *ngIf="selectedConsultation && selectedConsultation.id">
                    <div class="card-body">

                        <form #optiqueForm="ngForm" (ngSubmit)="confirmSaveItem(itemToSave)" class="optique-form">

                            <!-- Progress Indicator -->
                            <div class="progress-indicator">
                                <div class="progress-dot" [class.active]="currentTab === 0"></div>
                                <div class="progress-dot" [class.active]="currentTab === 1"></div>
                                <div class="progress-dot" [class.active]="currentTab === 2"></div>
                                <div class="progress-dot" [class.active]="currentTab === 3"></div>
                                <div class="progress-dot" [class.active]="currentTab === 4"></div>
                            </div>

                            <!-- Tab Navigation -->
                            <div class="tab-navigation">
                                <button type="button" class="tab-button" [class.active]="currentTab === 0"
                                    (click)="setTab(0)">
                                    <span class="icon">👁️</span>
                                    <span>Œil Droit</span>
                                </button>
                                <button type="button" class="tab-button" [class.active]="currentTab === 1"
                                    (click)="setTab(1)">
                                    <span class="icon">👁️</span>
                                    <span>Œil Gauche</span>
                                </button>
                                <button type="button" class="tab-button" [class.active]="currentTab === 2"
                                    (click)="setTab(2)">
                                    <span class="icon">📏</span>
                                    <span>Distance</span>
                                </button>
                                <button type="button" class="tab-button" [class.active]="currentTab === 3"
                                    (click)="setTab(3)">
                                    <span class="icon">⚙️</span>
                                    <span>Type & Traitement</span>
                                </button>
                                <button type="button" class="tab-button" [class.active]="currentTab === 4"
                                    (click)="setTab(4)">
                                    <span class="icon">🔍</span>
                                    <span>Filtres</span>
                                </button>
                            </div>

                            <!-- Tab Contents -->
                            <div class="tab-content" [class.active]="currentTab === 0">
                                <div class="section">
                                    <h3>👁️ Œil Droit</h3>
                                    <div class="grid-fields">
                                        <div class="field">
                                            <label for="od_sph">Sphère (distance)</label>
                                            <input id="od_sph" name="oeil_droit_sph" type="text"
                                                [(ngModel)]="itemToSave.oeil_droit_sph" class="form-control"
                                                placeholder="ex: -2.00"
                                                title="Correction de la myopie (-) ou hypermétropie (+). Valeurs typiques : -6.00 à +6.00">
                                        </div>
                                        <div class="field">
                                            <label for="od_cyl">Cylindre</label>
                                            <input id="od_cyl" name="oeil_droit_cyl" type="text"
                                                [(ngModel)]="itemToSave.oeil_droit_cyl" class="form-control"
                                                placeholder="ex: -1.00"
                                                title="Correction de l'astigmatisme (toujours négatif ou 0). Valeurs typiques : 0.00 à -3.00">
                                        </div>
                                        <div class="field">
                                            <label for="od_axe">Axe</label>
                                            <input id="od_axe" name="oeil_droit_axe" type="text"
                                                [(ngModel)]="itemToSave.oeil_droit_axe" class="form-control"
                                                placeholder="ex: 90°"
                                                title="Orientation de l'astigmatisme en degrés. Valeurs : 0° à 180°">
                                        </div>
                                        <div class="field">
                                            <label for="od_add">Addition (près)</label>
                                            <input id="od_add" name="oeil_droit_add" type="text"
                                                [(ngModel)]="itemToSave.oeil_droit_add" class="form-control"
                                                placeholder="ex: +2.00"
                                                title="Correction pour la presbytie (vision de près). Valeurs typiques : +1.00 à +3.50">
                                        </div>
                                    </div>
                                    <div class="copy-section">
                                        <button type="button" class="btn btn-secondary" (click)="copyRightToLeft()">
                                            Copier vers Œil Gauche →
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-content" [class.active]="currentTab === 1">
                                <div class="section">
                                    <h3>👁️ Œil Gauche</h3>
                                    <div class="grid-fields">
                                        <div class="field">
                                            <label for="og_sph">Sphère (distance)</label>
                                            <input id="og_sph" name="oeil_gauche_sph" type="text"
                                                [(ngModel)]="itemToSave.oeil_gauche_sph" class="form-control"
                                                placeholder="ex: -2.00">
                                        </div>
                                        <div class="field">
                                            <label for="og_cyl">Cylindre</label>
                                            <input id="og_cyl" name="oeil_gauche_cyl" type="text"
                                                [(ngModel)]="itemToSave.oeil_gauche_cyl" class="form-control"
                                                placeholder="ex: -1.00">
                                        </div>
                                        <div class="field">
                                            <label for="og_axe">Axe</label>
                                            <input id="og_axe" name="oeil_gauche_axe" type="text"
                                                [(ngModel)]="itemToSave.oeil_gauche_axe" class="form-control"
                                                placeholder="ex: 90°">
                                        </div>
                                        <div class="field">
                                            <label for="og_add">Addition (près)</label>
                                            <input id="og_add" name="oeil_gauche_add" type="text"
                                                [(ngModel)]="itemToSave.oeil_gauche_add" class="form-control"
                                                placeholder="ex: +2.00">
                                        </div>
                                    </div>
                                    <div class="copy-section">
                                        <button type="button" class="btn btn-secondary" (click)="copyLeftToRight()">
                                            ← Copier vers Œil Droit
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-content" [class.active]="currentTab === 2">
                                <div class="section">
                                    <h3>📏 Distance Interpupillaire</h3>
                                    <div class="single-field">
                                        <div class="field">
                                            <label for="distance_inter">Distance Interpupillaire (mm)</label>
                                            <input id="distance_inter" name="distance_interpupillaire" type="text"
                                                [(ngModel)]="itemToSave.distance_interpupillaire" class="form-control"
                                                placeholder="ex: 62 mm">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-content" [class.active]="currentTab === 3">
                                <div class="section checkbox-section">
                                    <h3>⚙️ Type de Verres</h3>
                                    <div class="checkbox-group">
                                        <div class="form-check">
                                            <input id="type_double_foyer" name="type_double_foyer" type="checkbox"
                                                [(ngModel)]="itemToSave.type_double_foyer" class="form-check-input">
                                            <label for="type_double_foyer" class="form-check-label">Double Foyer</label>
                                        </div>
                                        <div class="form-check">
                                            <input id="type_progressif" name="type_progressif" type="checkbox"
                                                [(ngModel)]="itemToSave.type_progressif" class="form-check-input">
                                            <label for="type_progressif" class="form-check-label">Progressif</label>
                                        </div>
                                    </div>

                                    <h3 style="margin-top: 2rem;">🔧 Traitement</h3>
                                    <div class="checkbox-group">
                                        <div class="form-check">
                                            <input id="traitement_teinte" name="traitement_teinte" type="checkbox"
                                                [(ngModel)]="itemToSave.traitement_teinte" class="form-check-input">
                                            <label for="traitement_teinte" class="form-check-label">Teinte</label>
                                        </div>
                                        <div class="form-check">
                                            <input id="traitement_antireflet" name="traitement_antireflet"
                                                type="checkbox" [(ngModel)]="itemToSave.traitement_antireflet"
                                                class="form-check-input">
                                            <label for="traitement_antireflet"
                                                class="form-check-label">Antireflet</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-content" [class.active]="currentTab === 4">
                                <div class="section checkbox-section">
                                    <h3>🔍 Filtres</h3>
                                    <div class="checkbox-group">
                                        <div class="form-check">
                                            <input id="filtre_photocromique" name="filtre_photocromique" type="checkbox"
                                                [(ngModel)]="itemToSave.filtre_photocromique" class="form-check-input">
                                            <label for="filtre_photocromique"
                                                class="form-check-label">Photocromique</label>
                                        </div>
                                        <div class="form-check">
                                            <input id="filtre_anti_uv" name="filtre_anti_uv" type="checkbox"
                                                [(ngModel)]="itemToSave.filtre_anti_uv" class="form-check-input">
                                            <label for="filtre_anti_uv" class="form-check-label">Anti-UV</label>
                                        </div>
                                        <div class="form-check">
                                            <input id="filtre_transition" name="filtre_transition" type="checkbox"
                                                [(ngModel)]="itemToSave.filtre_transition" class="form-check-input">
                                            <label for="filtre_transition" class="form-check-label">Transition</label>
                                        </div>
                                        <div class="form-check">
                                            <input id="filtre_antibuee" name="filtre_antibuee" type="checkbox"
                                                [(ngModel)]="itemToSave.filtre_antibuee" class="form-check-input">
                                            <label for="filtre_antibuee" class="form-check-label">Anti-Buée</label>
                                        </div>
                                        <div class="form-check">
                                            <input id="filtre_bleu" name="filtre_bleu" type="checkbox"
                                                [(ngModel)]="itemToSave.filtre_bleu" class="form-check-input">
                                            <label for="filtre_bleu" class="form-check-label">Filtre Bleu</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Navigation Buttons -->
                            <div class="tab-navigation-buttons">
                                <button type="button" class="btn btn-secondary" (click)="previousTab()"
                                    [disabled]="currentTab === 0">
                                    ← Précédent
                                </button>

                                <button type="button" class="btn btn-secondary" (click)="nextTab()"
                                    [hidden]="currentTab === 4">
                                    Suivant →
                                </button>

                                <button type="submit" class="btn btn-primary" [hidden]="currentTab !== 4">
                                    💾 Enregistrer
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Patient Information -->


    <!-- Prescription Form -->

</div>